export const titleChanger = (title, description, keywords) => {
    if (title != null) {
        document.title = title;
        document.querySelector('meta[name="description"]').setAttribute("content", description ? description : '');
        document.querySelector('meta[name="keywords"]').setAttribute("content", keywords ? keywords : '');
    }
}